import BaseModulePlugins from '@/store/baseModule/plugins';
import registerDashboard from './dashboardDispatcher.store';
import SelectedRequests from '@/store/modules/dashboardDispatcher/SelectedRequests';

export default (store) => {
  registerDashboard(store);

  store.registerModule('dashboardDispatcher/selected', SelectedRequests);

  const basePlugins = new BaseModulePlugins({
    module: 'dashboardDispatcher/selected',
    store,
  });

  basePlugins.persistVuexMutationsToLocalStorage(['SET_PARAMS']);
};
